document.addEventListener("DOMContentLoaded", () => {
  $(document).on("click", "#line-idle-get", function () {
    const line = $(this).attr("line")

    loadModal({
      title: "Idle",
      url: "/dashboard/idles/" + line
    })
  })

  $(document).on("click", ".line-set-idle", function () {
    $(".line-set-idle").each(function (idx, elm) {
      $(elm).removeAttr('selected')
    })

    $(this).attr("selected", true)

    const line = $("#line-idle-get").attr("line")
    const idle_name = $(this).text()

    $("#idle-selection-confirmation").find(".line").val(line)
    $("#idle-selection-confirmation").find(".idle").val(idle_name)

    $("#idle-selection").attr("hidden", "hidden")
    $("#idle-selection-confirmation").removeAttr("hidden")
  })

  $(document).on("click", "#line-idle-cancel-confirmation", function () {
    $("#idle-selection").removeAttr("hidden")
    $("#idle-selection-confirmation").attr("hidden", "hidden")
    $("#idle-selection-confirmation .remarks").val("")
  })

  $(document).on("click", "#line-idle-confirm-confirmation", function () {
    const line = $("#line-idle-get").attr("line")
    const idle = $(".line-set-idle[selected='selected']").attr("record_id")
    const remarks = $("#idle-selection-confirmation .remarks").val()

    $.ajax({
      url: "/dashboard/idles/" + line,
      method: "PATCH",
      data: {
        idle_id: idle,
        remarks: remarks
      },
      headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
      success: function (res) {
        hideModal()
        loadPage(res.redirect)
      },
      error: function (jqXHR) {
        alert(jqXHR.responseJSON.message)
      }
    })
  })

  $(document).on("click", "#line-idle-unset", function () {
    const line_idle = $(this).attr("line_idle")
    const line = $(this).attr("line")

    if (!confirm(`Apakah anda yakin STOP idle LINE ${line}?`)) {
      return false;
    }

    $.ajax({
      url: "/dashboard/idles/" + line_idle,
      method: "DELETE",
      headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
      success: function (res) {
        loadPage(window.location.href, false)
      },
      error: function (jqXHR) {
        console.log('b')
      }
    })
  })
})